import Link from 'next/link';
import { type FC } from 'react';

export const InternalLink: FC<{ href: string; text: string; id: string }> = ({
  href,
  text,
  id,
}) => (
  <Link href={href} className="link normal-case text-leland-primary" id={id}>
    {text}
  </Link>
);
